// src/api/client.js
import axios from 'axios';
import { getAnonymousId } from '../utils/anonymousId.js';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3381/api/v1';

const client = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Перехватчик для добавления токена и идентификатора гостевой сессии
client.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('access_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // ============================================================
    // 🔴 БЕЗ ЭТОЙ СТРОКИ ГОСТЕВАЯ КОРЗИНА НЕ РАБОТАЛА ВООБЩЕ.
    //
    //    Бэкенд опознаёт гостя по заголовку `x-session-id`
    //    (`cartController.js`). Без пользователя И без заголовка он
    //    отвечает 400 «User ID or session ID is required».
    //
    //    Замер ДО правки (клик «В корзину» в реальном браузере):
    //        запрос: sessionHeader: null
    //        ответ:  400 Bad Request
    //    То есть НИ ОДИН неавторизованный посетитель не мог ничего
    //    купить — корзина была сломана для всех, кто не вошёл.
    //
    //    ⚠️ Почему не замечали: curl с этим заголовком работал (curl
    //       не делает CORS-preflight), а автотестов UI в проекте нет.
    //       Баг воспроизводился ТОЛЬКО в браузере.
    //
    //    🔑 Используется ТОТ ЖЕ идентификатор, что и для согласий
    //       (`getAnonymousId`), — намеренно. Второй ID с другим ключом
    //       означал бы, что сервер видит ДВУХ «анонимов» у одного
    //       браузера: согласие привязано к одному, корзина к другому.
    //
    //    ⚠️ Отправляем ВСЕГДА, даже когда есть токен: это безвредно
    //       (бэкенд предпочитает user_id) и избавляет от ветвлений.
    // ============================================================
    const anonymousId = getAnonymousId();
    if (anonymousId) {
      config.headers['x-session-id'] = anonymousId;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Перехватчик для обработки ошибок
client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Если 401 и не пробовали обновить токен
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const refreshToken = localStorage.getItem('refresh_token');
        if (refreshToken) {
          const response = await axios.post(`${API_URL}/auth/refresh`, {
            refresh_token: refreshToken,
          });
          const { access_token, refresh_token } = response.data.data;
          localStorage.setItem('access_token', access_token);
          localStorage.setItem('refresh_token', refresh_token);
          originalRequest.headers.Authorization = `Bearer ${access_token}`;
          return client(originalRequest);
        }
      } catch (refreshError) {
        // Если не удалось обновить — выходим
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default client;